/** CandidateDrawerCard.jsx **/
import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';

import CloseIcon from '@mui/icons-material/Close';

const CardContainer = styled(Box)`
  display: flex;
  gap: 12px;
  padding: 16px;
  margin: 12px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  position: relative;
`;

const InfoBox = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

const EmailText = styled(Typography)`
  font-size: 14px;
  color: #555;
  word-break: break-word;
`;


const StyledAvatar = styled(Avatar)`
  background-color: #3f51b5;
  color: #fff;
  font-weight: bold;
  margin-top: 9px;
`;

const RemoveButton = styled(IconButton)`
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px;
  color: #999;
  &:hover {
    color: #e53935;
  }
`;

export const CandidateCard = ({ candidate, onRemove }) => {
  const initials = candidate.name
    ? candidate.name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
    : '';
  return (
    <CardContainer>
      <StyledAvatar>{initials}</StyledAvatar>
      <InfoBox>
        <Typography variant="subtitle1" fontWeight={600}>
          {candidate.name}
        </Typography>
        <EmailText>{candidate.emailID}</EmailText>
      </InfoBox>
      <RemoveButton onClick={() => onRemove(candidate.candidateId)}>
        <CloseIcon fontSize="small" />
      </RemoveButton>
    </CardContainer>
  );
};
